import { Select } from "antd";
import { SetStateAction, useCallback, useMemo, useState } from "react";
import { selectSite } from "../../../util/store/site/constants";
import { useSelector } from "../../../util/store/store";
import { IFishGroup } from "../../../util/varibles/interface";

interface IProps {
    onChange(value: SetStateAction<{ site_id: string, group_id: string, site_name: string, group_name: string }[]>): void
}

const Title: React.FC<IProps> = ({ onChange }) => {
    const { data: fishgroup } = useSelector(selectSite.fishGroup);
    const [siteId, setSiteId] = useState<string | undefined>();

    const siteOpts = useMemo(() => {
        const result = fishgroup.reduce((rs: { [id: string]: string }, item) => {
            rs[item.site_id] = item.site_name;
            return rs;
        }, {})
        return Object.keys(result).map(key => ({ value: key, label: result[key] }))
    }, [fishgroup]);

    const opts = useMemo(() => {
        if ((siteId || "").length > 0)
            return fishgroup.filter(item => item.site_id === siteId).map(item => ({ value: item.group_name, label: item.group_id, root: item }));
        return fishgroup.map((item, i) => ({ value: item.group_id + i, label: item.group_id, root: item }));
    }, [siteId, fishgroup])

    const handleFishgroupChange = useCallback((data: IFishGroup) => {
        onChange(prev => {
            const isAdd = prev.some(item => item.group_id === data.group_id);
            return isAdd ? prev : [...prev, data]
        })
    }, [onChange])

    return <div className="flex gap-2 items-center justify-end">
        <div className="text-comment mr-1 mt-[4px]">
            Compare FGI:
        </div>
        <Select className="select-single w-[240px]" placeholder="Select site" value={siteId} onChange={setSiteId} options={siteOpts} allowClear />
        <Select className="select-single w-[360px]" placeholder="Select a fish group Id to compare" options={opts} value={undefined} onSelect={(_, opt) => handleFishgroupChange(opt.root)} />
    </div>
}

export default Title;